// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"52":"df93acc0","136":"3b0e53d5","453":"03346f77"}[chunkId] + ".chunk.js";
};